import { useCallback } from "react";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import {
  ensureMicrophonePermission,
  getMicrophoneAccessErrorMessage,
} from "../_utils/requestMicrophoneAccess.utils";

export const useRequireMicrophoneForCall = () => {
  const { showSnackbar } = useGlobalSnackbar();

  return useCallback(async (): Promise<boolean> => {
    const result = await ensureMicrophonePermission();
    if (result.ok === false) {
      showSnackbar(getMicrophoneAccessErrorMessage(result.reason), "error", 6000, "bottom-center");
      return false;
    }

    return true;
  }, [showSnackbar]);
};
